import { OrderLimitType } from '@/constants/enum';
import { pickupSettingSelector } from '@/redux/slice/pickup.slice';
import { ITimeSlot } from '@/types';
import { time24hTo12h } from '@/utils';
import { InlineGrid, Select, TextField } from '@shopify/polaris';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const WorkingHour = ({
  time24h,
  workingHour,
  frequency,
  setWorkingHour,
}: {
  time24h: { id: number; value: string }[];
  workingHour: ITimeSlot;
  frequency?: string;
  setWorkingHour: (workingHour: ITimeSlot) => void;
}) => {
  const { t } = useTranslation('pickupSettings');
  const pickupSettings = useSelector(pickupSettingSelector);

  const timeStarts = useMemo(() => {
    return time24h.map((item) => ({
      key: item.value,
      label: time24hTo12h(item.value),
      value: item.value,
    }));
  }, [time24h]);

  const timeEnds = useMemo(() => {
    const startIndex = time24h.findIndex((item) => item.value === workingHour.start);
    return time24h.slice(startIndex).map((item) => ({
      key: item.value,
      label: time24hTo12h(item.value),
      value: item.value,
    }));
  }, [time24h, workingHour.start]);

  return (
    <>
      <InlineGrid columns="1fr 1fr auto" gap="200">
        <Select
          label={t('pickupTime.timeSlot.from.label')}
          placeholder={t('pickupTime.timeSlot.from.placeholder')}
          options={timeStarts}
          value={workingHour.start}
          onChange={(value) => setWorkingHour({ ...workingHour, start: value })}
        />
        <Select
          label={t('pickupTime.timeSlot.until.label')}
          placeholder={t('pickupTime.timeSlot.until.placeholder')}
          options={timeEnds}
          value={workingHour.end}
          onChange={(value) => setWorkingHour({ ...workingHour, end: value })}
        />
      </InlineGrid>
      {pickupSettings.orderLimitType === OrderLimitType.LIMIT_PER_TIMESLOT && (
        <TextField
          label={t('orderLimit.limitPerTimeSlotLabel', { time: t(`frequency.label.${frequency}`) })}
          placeholder={t('orderLimit.title')}
          type="number"
          value={workingHour?.orderLimit?.toString()}
          onChange={(value) => {
            setWorkingHour({ ...workingHour, orderLimit: Number(value) });
          }}
          autoComplete="off"
          min={0}
          step={1}
        />
      )}
    </>
  );
};

export default WorkingHour;
